import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <CommentsSection />
        <TopicsSection />
        <CarouselSection />
        <RankingSection />
        <MediaSection />
        <UpdatesSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}